import React from 'react'
import { Form } from "react-bootstrap";

export default function UiCardRadioBtn(props) {


    return (
        <>
            <div className="sb-radio-card">
                <Form.Check
                    type="radio"
                    id={props.id}
                    name={props.name}
                />
                <label class="form-check-label" for={props.id}>
                    <img src={props.icon} />
                </label>
            </div>

        </>
    )
}
